export default __webpack_public_path__ + "static/media/8.1f781443.jpg";